pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.header_slider = {

	init: function(){

			console.log('header sliders was inited?');

			let html = '';

			let videos_total = 0;

			//let videos_array = [];

			$.ajax({

				url: endpoint+'/cms/zones/61/objects',
				method: 'get'

			}).done( r => {

				console.log( r );
				
				$.each( r, ( k, i ) =>{

					// testing
					//i.article_type = 'Image';
					//i.bannerimg = 'https://placeholdit.imgix.net/~text?txtsize=125&txt=1920%C3%97500&w=1920&h=500';

					if( i.article_type == 'Image' ){

						html += 

						`<div class="slide">			
							
							<div class="image" style="background-image: url('${ i.bannerimg }')"></div>

							<div class="description">

								<div class="text">${ i.hptitle }</div>

								<a href="${ i.hpurl || '#' }" class="btn btn-primary">

									${ i.hpmenutitle }

								</a>

							</div>

						</div>`;

					}else if( i.article_type == 'Video' ){

						videos_total ++;

						let url_parts = i.hpurlvideo.split('/');
						
						if( url_parts[2] != 'vimeo.com' ){

							console.log( i.url+' - sorry, vimeo videos only!');
							return 0;

						}

						let video_id = url_parts[ url_parts.length - 1 ];					

						//console.log( i.hpurlvideo );
						//console.log( video_id );

						html += 

						`<div class="slide" style="background:#000">

							<div class="video-loader" style="color:#ccc; text-align:center; width: 100%; margin-top: 20%;">							

								loading Pyzel video...

							</div>			

							<iframe id="vimeo-${video_id}" class="vimeo-iframe" data-id-video="${video_id}" src="https://player.vimeo.com/video/${video_id}?byline=0&amp;portrait=0&amp;loop=0" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

						</div>`;

					}	
					
				})
				
				$('#header-slider').html( html );

				//--------------------------------------------------------------

				if( videos_total > 0 ){				

					// script was failing to load, so do a plan B
					$.getScript( "https://player.vimeo.com/api/player.js" ).done(function( script, textStatus ) {
					    
						//console.log( 'script loaded' );

						$.each( $('.vimeo-iframe'), ( k, i ) =>{
				    	
				    	//console.log( $( i ).data('id-video') );
				    				    	
					    //var iframe = $('.vimeo-iframe')
					    var player = new Vimeo.Player( $('#vimeo-'+ $( i ).data('id-video') ) );

					    player.on('loaded', function() {

					        console.log('the video was loaded!');

					        $('.video-loader').remove();

					    });				    
					    
					    player.on('play', function() {

					        console.log('played the video!');

					        $('#header-slider').slick('slickPause');

					        // if playing, listen to slick changes to stop the video						
							$('#header-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
							  						 
							  player.pause();

							});

					    });			    	

					    //player.on('pause', function() {
					    // born buggy..? can´t have the api=1 on the embed url				    
					    player.on('ended', function() {	

					        console.log('the video stopped!'); // not firing??

					        //$('#header-slider').slick('slickStart');
					        //$('#header-slider').slick('reinit');
					        $('#header-slider').slick('slickPlay');

					        // got to first frame of video - default state
					        setTimeout(

					        	function(){

									player.unload();
									console.log('player was unloaded');

					        	}, 500

					        )				        

					    });												   
						
				    }) // end each						
					  
					  }).fail(function( jqxhr, settings, exception ) {

					    console.log( 'script NOT loaded' );

					});													

				}else{

					console.log( 'no videos ara available' );					

				} 

				//--------------------------------------------------------------
			    
				pyzel.sliders.homepageTop();


			})

		}

	//)

} 